export default __webpack_public_path__ + "static/media/map.046d3c90.png";